import { useCallback } from 'react';

import {
  FeedbackMessages,
  useFeedback,
} from '@/components/notifications/Feedback/useFeedback';
import { useReportError } from '@/hooks/useReportError';
import { GenerateMemoInput } from '@/types/schema';

import { useGenerateMemoMutation } from '../graphql/GenerateMemo.generated';

export function useGenerateMemo() {
  const { showFeedback } = useFeedback();
  const { reportError } = useReportError();

  const [generateMemo, { loading }] = useGenerateMemoMutation({
    refetchQueries: 'active',
    awaitRefetchQueries: true,
  });

  const runGenerateMemo = useCallback(
    async (input: GenerateMemoInput) => {
      try {
        const result = await generateMemo({
          variables: {
            input,
          },
        });

        const workflowTracker = result.data?.generateMemo;
        if (!workflowTracker) {
          throw new Error(
            'Memo generation returned no workflow tracker record.'
          );
        }

        showFeedback('Memo generation started', { variant: 'success' });

        return workflowTracker;
      } catch (error) {
        showFeedback(FeedbackMessages.formSaveError);
        reportError('Could not generate memo', error as Error);
        throw error;
      }
    },
    [generateMemo, reportError, showFeedback]
  );

  return {
    generateMemo: runGenerateMemo,
    loading,
  };
}
